/* eslint-disable no-underscore-dangle */
import ReactPlayerLoader from '@brightcove/react-player-loader';
import { arrayOf, string } from 'prop-types';
import React from 'react';

const BrightcovePlayer = (props) => {
  const { accountId, classNames, playerId, productId, videoId } = props;
  const onSuccess = (success) => {
    const { ref } = success;
    const { boundUpdateCurrentBreakpoint_: updateCurrentBreakpoint, breakpoints_: breakpoints, player_: player } = ref;
    const sendVideoEventAnalytics = (eventName) => {
      const thdAnalyticsEvent = {
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName },
        video: {
          id: videoId,
          type: window.digitalData.page.pageInfo.pageType,
        },
      };
      window.ddoEventInit(thdAnalyticsEvent);
    };

    player.one('play', () => sendVideoEventAnalytics('video start'));
    player.on('ended', () => sendVideoEventAnalytics('video complete'));

    window.updateCurrentBreakpoint = updateCurrentBreakpoint;
    updateCurrentBreakpoint(breakpoints.large);
    // eslint-disable-next-line no-underscore-dangle
    ref.breakpoint_ = breakpoints.large;
  };

  const onFailure = (failure) => {
    console.log(failure);
  };

  return (
    <ReactPlayerLoader
      accountId={accountId}
      productId={productId}
      playerId={playerId}
      onSuccess={onSuccess}
      onFailure={onFailure}
      attrs={{ className: classNames.join(' ') }}
      videoId={videoId}
      embedOptions={{ responsive: { aspectRatio: '16:9', maxWidth: '1500px' } }}
    />
  );
};

BrightcovePlayer.propTypes = {
  accountId: string,
  classNames: arrayOf(string),
  playerId: string,
  productId: string,
  videoId: string,
};

BrightcovePlayer.defaultProps = {
  accountId: '6248889401001',
  classNames: [],
  playerId: 'NFnZhnSNG',
  productId: null,
  videoId: null,
};

export default BrightcovePlayer;
